import { render, staticRenderFns } from "./DefesaComercial.vue?vue&type=template&id=2889ae68&scoped=true&"
import script from "./DefesaComercial.vue?vue&type=script&lang=js&"
export * from "./DefesaComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889ae68",
  null
  
)

export default component.exports